// Core ride-ingest path shared by every adapter trigger — the settings dialog,
// the dashboard autosync on reload, and (transitively) the Wahoo OAuth return,
// which redirects to the dashboard where autosync runs the first load. Whoever
// produces a { rides, message } batch routes it through here, so the analytics
// event fires from one place regardless of what kicked off the load.

import { saveRides, getMeta, setMeta } from './db.js';
import { trackEvent } from './telemetry.js';

// Persist a freshly produced batch and emit the completion event.
//   trigger — what initiated the load: 'manual' (a settings-dialog action),
//             'autosync' (the on-load background sync), or 'auto-demo' (the
//             first-visit demo auto-load).
//   phase   — derived, not passed: 'initial' for the first successful load of
//             an adapter (no lastOp bookmark yet), 'update' for every later one.
// Returns { phase, savedCount } so callers can decide whether to refresh the UI.
export async function ingestLoad(adapter, { rides = [], message = '' } = {}, { trigger } = {}) {
  const phase = (await getMeta(`lastOp_${adapter.id}`)) ? 'update' : 'initial';

  if (rides.length) await saveRides(rides);

  await setMeta(`lastOp_${adapter.id}`, {
    timestamp: new Date().toISOString(),
    message,
  });

  // The loaded adapter becomes the active source for ongoing ingest (ADR-0005),
  // regardless of kind. Reload behaviour is decided by the adapter's `kind`, not
  // by a separate key.
  await setMeta('activeAdapter', adapter.id);

  trackEvent('adapter_sync_complete', { adapter: adapter.id, phase, trigger });

  return { phase, savedCount: rides.length };
}
